import React from "react";
import { PhaseCheckbox } from "./";

export const PhaseColumn = ({
  exactWeek,
  phases,
  weekFirstDay,
  handlePhaseSelection,
  phasesAttachments,
}) => {
  return (
    <div key={exactWeek} className="phase-column">
      {phases &&
        phases.map((phase, index) => (
          //   Checkbox for each training phase
          <PhaseCheckbox
            key={`phase-column-${index}-${Math.random().toString(16).slice(2)}`}
            classNames="phase-checkbox"
            name={exactWeek}
            phase={phase}
            phasesAttachments={phasesAttachments}
            handlePhaseSelection={handlePhaseSelection}
            index={index}
            weekFirstDay={weekFirstDay}
          />
        ))}
    </div>
  );
};
